// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { DirectMessageBaseClass } from './DirectMessageBase';
import { SessionOperations } from '../../Utils/Enums/Constants';
import { Message } from './Message';
export class DirectTradeSessionStatusMessage extends DirectMessageBaseClass {
    constructor() {
        super(Message.CODE_TRADE_SESSION_STATUS_MESSAGE);
        this.Id = 0;
        this.Name = null;
        this.AllowedOrderTypes = [];
        this.AllowedTIFs = [];
        this.AllowedOperations = SessionOperations.None;
        this.IsDecreaseOnlyPositionCount = false;
    }
}
